/** Trim segments and normalize commas between option tokens for API storage. */
export function normalizeCommaSeparatedOptions(raw: string): string {
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .join(', ');
}
